import { instance } from '@/api/defaultApi'
import { ResponseError } from '@/classes/ResponseError'

export function get (url, params = {}) {
  return instance.get(`/${url}`, { params })
}

function getById (url, id, params = {}) {
  return instance.get(`/${url}/${id}`, { params })
}

function create (url, data = {}, params = {}) {
  return instance.post(`/${url}`, data, { params })
}

// При создании через этот метод, на бэкэ идет валидация, чтобы не создавались записи с одинаковыми именами
export function createUnique (url, data = {}, params = {}) {
  return instance.post(`/${url}/find-or-create`, data, { params })
}

function update (url, id, data = {}, params = {}) {
  return instance.put(`/${url}/${id}`, data, { params })
}

function destroy (url, id) {
  return instance.delete(`/${url}/${id}`)
}

function destroyList (url, list) {
  return Promise.all(list.map(item => destroy(url, item.id)))
}

// Файлы
// data = { files: FileList[] }
export function postFilesFormData (url, id, data, params) {
  return instance.postForm(`/${url}/${id}/files`, data, { params })
}
// data = { files: number[] }
function deleteFiles (url, id, data) {
  return instance.put(`/${url}/${id}/remove-files`, data)
}
export async function putFilesSort (ids) {
  try {
    return await instance.put('files/sort', ids)
  } catch (e) {
    throw new ResponseError(e, 'Не удалось сохранить сортировку файлов')
  }
}

export async function sendEmail (url, id, data = {}) {
  try {
    return await instance.post(`/${url}/${id}/send`, data)
  } catch (e) {
    throw new ResponseError(e, 'Ошибка отправки письма')
  }
}

export function createBaseCRUDApi (url, errors) {
  return {
    getAll: async (params) => {
      try {
        return await get(url, params)
      } catch (e) {
        throw new ResponseError(e, errors.getAll)
      }
    },
    getById: async (id, params) => {
      try {
        return await getById(url, id, params)
      } catch (e) {
        throw new ResponseError(e, errors.getById)
      }
    },
    create: async (data, params) => {
      try {
        return await create(url, data, params)
      } catch (e) {
        throw new ResponseError(e, errors.create)
      }
    },
    update: async (id, data, params) => {
      try {
        return await update(url, id, data, params)
      } catch (e) {
        throw new ResponseError(e, errors.update)
      }
    },
    destroy: async (id) => {
      try {
        return await destroy(url, id)
      } catch (e) {
        throw new ResponseError(e, errors.destroy)
      }
    },
    destroyList: async (ids) => {
      try {
        return await destroyList(url, ids)
      } catch (e) {
        throw new ResponseError(e, errors.destroyList)
      }
    }
  }
}

export function createBaseFilesApi (url) {
  return {
    postFilesFormData: async (id, data, params = { expand: 'files' }) => {
      try {
        return await postFilesFormData(url, id, data, params)
      } catch (e) {
        throw new ResponseError(e, 'Ошибка при сохранении новых файлов')
      }
    },
    deleteFiles: async (id, data) => {
      try {
        return await deleteFiles(url, id, data)
      } catch (e) {
        throw new ResponseError(e, 'Ошибка при удалении файлов')
      }
    }
  }
}

export function createCreateUniqueApi (url, errors) {
  return {
    createUnique: async (data) => {
      try {
        return await createUnique(url, data)
      } catch (e) {
        throw new ResponseError(e, errors.createUnique)
      }
    }
  }
}
